var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"mdl",rawName:"v-mdl"}],staticClass:"spinner",attrs:{"id":"loading"}},[_c('div',{staticClass:"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active"})])}
var staticRenderFns = []

export { render, staticRenderFns }